export const ADD_BRAND_REQUEST = "ADD_BRAND_REQUEST";
export const ADD_BRAND_SUCCESS = "ADD_BRAND_SUCCESS";
export const ADD_BRAND_FAIL = "ADD_BRAND_FAIL";

export const FETCH_BRAND_REQUEST = "FETCH_BRAND_REQUEST";
export const FETCH_BRAND_SUCCESS = "FETCH_BRAND_SUCCESS";
export const FETCH_BRAND_FAIL = "FETCH_BRAND_FAIL";

export const FETCH_BRAND_ID_REQUEST = "FETCH_BRAND_ID_REQUEST";
export const FETCH_BRAND_ID_SUCCESS = "FETCH_BRAND_ID_SUCCESS";
export const FETCH_BRAND_ID_FAIL = "FETCH_BRAND_ID_FAIL";

export const FETCH_BRAND_STATUS_REQUEST = "FETCH_BRAND_STATUS_REQUEST";
export const FETCH_BRAND_STATUS_SUCCESS = "FETCH_BRAND_STATUS_SUCCESS";
export const FETCH_BRAND_STATUS_FAIL = "FETCH_BRAND_STATUS_FAIL";

export const BRAND_ACTIVE_REQUEST = "BRAND_ACTIVE_REQUEST";
export const BRAND_ACTIVE_SUCCESS = "BRAND_ACTIVE_SUCCESS";
export const BRAND_ACTIVE_FAIL = "BRAND_ACTIVE_FAIL";

export const BRAND_INACTIVE_REQUEST = "BRAND_INACTIVE_REQUEST";
export const BRAND_INACTIVE_SUCCESS = "BRAND_INACTIVE_SUCCESS";
export const BRAND_INACTIVE_FAIL = "BRAND_INACTIVE_FAIL";

export const UPDATE_BRAND_REQUEST = "UPDATE_BRAND_REQUEST";
export const UPDATE_BRAND_SUCCESS = "UPDATE_BRAND_SUCCESS";
export const UPDATE_BRAND_FAIL = "UPDATE_BRAND_FAIL";